<template>
    <div @click="goToServiceHandler(imageURL)" class="Card">

		<div class="Card__imageContainer">
			<img :src="require(`@/assets/images/cards/${imageURL}.jpg`)" :alt="imageURL">
		</div>

		<div class="Card__content">
			<div>
				<h4>{{ cardTitle }}</h4>
			</div>
			<div>
				<p>{{ shortenTitle(cardDescription, 79) }}</p>
			</div>
		</div>

    </div>
</template>

<script>
export default {
    name: 'Card',
    props: {
        imageURL: String,
		cardTitle: String,
		cardDescription: String,
		goToServiceHandler: Function
	},
	methods: {
		shortenTitle(title, len) {
			const titleArray = title.split('')

			if(titleArray.length > len) {
				return `${title.substr(0, len)}...`
			} else {
				return title
			}
		}
	}
}
</script>

<style lang="scss" scoped>

.Card {
	background: white;
    width: 80%;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    border-radius: 8px;
	padding: 20px;
	@include transition(0.1);

	@media screen and (min-width: 425px) {
		width: 100%;
	}
	@media screen and (min-width: 1440px) {
		width: 90%;
		cursor: pointer;

		&:hover {
			box-shadow: 0 3px 5px rgba(0, 0, 0, 0.12), 0 1px 5px rgba(0, 0, 0, 0.24);
		}
	}
	@media screen and (min-width: 1920px) {
		width: 80%;
	}

	&__imageContainer {
		margin-bottom: 20px;

		img {
			width: 100%;
			height: 200px;

			@media screen and (min-width: 425px) {
				height: 160px;
			}
			@media screen and (min-width: 1440px) {
				height: 250px;
			}
		}
	}

	&__content {
		div {
			h4 {
				margin: 5px 0;	
				text-transform: uppercase;
			}
			p {
				@include paragraphStyle(0.9, $grey, 10);
				margin-bottom: 0;
			}
		}
	}
}


</style>

// .content_container {
//     padding: 0 20px;

//     h4 {
//         color: black;
//         margin: 0;
//         // margin: 10px 0;
//         text-transform: uppercase;
//     }

//     p {
//         @include paragraphStyle(0.9, $grey, 10);
//     }
// }

// @media screen and (min-width: 768px) {
// 	.Card {
// 		width: 40%;
// 		max-width: 230px;
// 		margin: 10px;
// 	}

// 	.image_container {
// 		padding: 40px;
		
// 		img {
// 			height: 180px;
// 		}
// 	}
// }

// @media screen and (min-width: 1024px) {
// 	.Card {
// 		margin: 45px 10px;
// 		width: 60%;
// 		max-width: 300px;
// 	}
// 	.image_container {
// 		img {
// 			height: 230px;
// 		}
// 	}
// }

// @media screen and (min-width: 1200px) {
// 	.Card {
// 		margin: 45px 30px;
// 	}
// 	.image_container {
// 		padding: 30px;
// 	}
// }